// marker_healthsubsystem string → translation key
export const SUBSYSTEM_KEY = {
  // Core Membership
  "Sugar (Glucose) Metabolism":         "subsystemSugar",
  "Fat Metabolism":                      "subsystemFat",
  "Liver":                               "subsystemLiver",
  "Kidney":                              "subsystemKidney",
  "Pancreas":                            "subsystemPancreas",
  "Non-Organ-Specific":                  "subsystemNonOrgan",
  "Fat-Soluble-Vitamins":                "subsystemFatVit",
  "Water-Soluble-Vitamins":              "subsystemWaterVit",
  "Minerals Micro":                      "subsystemMinMicro",
  "Minerals-Macro":                      "subsystemMinMacro",
  "Acute Inflammation":                  "subsystemAcute",
  "Oxygen Transport":                    "subsystemOxygen",
  "Blood Vessel Repair":                 "subsystemRepair",
  "White Blood Cells (Leukocytes)":      "subsystemWhite",
  "Granular Leukocytes":                 "subsystemGrano",
  "Lymphocytes":                         "subsystemLympho",
  "Monocytes":                           "subsystemMono",
  // Arteriosclerosis Prevention
  "Cardiovascular Risk":                 "subsystemCvd",
  "Insulin Status":                      "subsystemInsulin",
  "Genetic Lipid Transportprotein":      "subsystemLipoa",
  "Mitochondrial energy production":     "subsystemEnergy",
  // Hormones
  "Steroid Hormones":                    "subsystemHormSter",
  "Protein Hormones":                    "subsystemHormProt",
  // Bones Health
  "Bone Breakdown":                      "subsystemBoneBreak",
  "Bone Mineralisation":                 "subsystemBoneMin",
  // Vitamins & Nutrients (different strings than Core for same concept)
  "Vitamins - fat soluble":              "subsystemFatVit",
  "Vitamins - water soluble":            "subsystemWaterVit",
  "Micro Minerals":                      "subsystemMinMicro",
  // Omega Health
  "Total fatty acids":                   "subsystemFattyTotal",
  "Polyunsaturated Fatty Acids (PUFA)":  "subsystemPUFA",
  "Omega-3 fatty acids":                 "subsystemOmega3",
  "Omega-6 fatty acids":                 "subsystemOmega6",
  "Monounsaturated Fatty Acids":         "subsystemMUFA",
  "Saturated Fatty Acids":               "subsystemSFA",
  // Thyroid Health
  "Functional Thyroid":                  "subsystemThyrFunc",
  // Fertility (Female) — "Reserver" is a typo in the API, mapped as-is
  "Ovarian Stock Reserver":              "subsystemAmh",
  // Prostate Cancer Prevention
  "Prostate Cancer Prevention":          "subsystemPsa",
};

// marker_category string → sidebar nav_ key
export const CATEGORY_NAV_KEY = {
  "Core Membership":             "nav_core_health",
  "Arteriosclerosis Prevention": "nav_arteriosclerosis_prevention",
  "Omega Health":                "nav_marker_omega_lifestyle",
  "Hormones":                    "nav_hormones_balance2",
  "Bones Health":                "nav_bones_health",
  "Vitamins & Nutrients":        "nav_vitamins_nutrients",
  "Thyroid Health":              "nav_thyroid_health",
  "Fertility (Female)":          "nav_female_fertility_amh2",
  "Prostate Cancer Prevention":  "nav_male_prostate_health_psa",
  "Colon Cancer Prevention":     "nav_stool_cancer_test_fob",
};
